<template>
    <e-charts
        :options="option"
        :init-options="initOptions"
        ref="map"
        autoresize
    />
</template>
<script>
import pieMixin from "@/views/common/m-chart-pie";
import { currency } from "_u/helper";
export default {
    name: "RingChartCenter",
    mixins: [pieMixin],
    props: {
        changeOptions: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            defaultOption: {
                isSplit: true,
                len: 10,
                sort: "desc",
            },
        };
    },
    computed: {
        option() {
            const co = Object.assign(this.defaultOption, this.changeOptions);
            console.log(co);
            this.sortList(co.data, co.sort);
            if (co.isSplit) {
                co.data = this.sliceList(co.data, co.len);
            }
            let totalPrice = 0;
            co.data.forEach((v) => {
                totalPrice += v.value;
            });
            return {
                title: {
                    text: co.titleText || "",
                    left: "center",
                    textStyle: {
                        fontWeight: 400,
                    },
                },
                tooltip: {
                    trigger: "item",
                    // formatter: "{a} <br/>{b} : {c} ({d}%)",
                    formatter: (params) => {
                        return `${params.seriesName || ""}
                        <br/>
                        ${params.name || ""}：${currency(params.value || 0)} (${
                            params.percent
                        }%)`;
                    },
                },
                legend: {
                    orient: "vertical",
                    right: 10,
                    top: "middle",
                    itemHeight: 17,
                    itemWidth: 17,
                    formatter: (name) => {
                        let data = co.data;
                        let target;
                        target = data.find((v) => v.name === name);
                        return `{a|${target?.name || ""}}{b|${currency(
                            target?.value || 0
                        )}}`;
                    },
                    textStyle: {
                        rich: {
                            a: {
                                width: 90,
                            },
                        },
                    },
                },
                series: [
                    {
                        name: co.seriesName || "访问量",
                        type: "pie",
                        radius: ["45%", "63%"],
                        center: ["28%", "50%"],
                        avoidLabelOverlap: true,
                        label: {
                            normal: {
                                show: true,
                                position: "center",
                                color: "#4c4a4a",
                                formatter: `{total|合计}\n\r{price|${currency(
                                    totalPrice
                                )}}`,
                                rich: {
                                    total: {
                                        fontSize: 12,
                                        color: "#555555",
                                    },
                                    price: {
                                        fontSize: 24,
                                        color: "#333333",
                                        lineHeight: 50,
                                    },
                                },
                            },
                            emphasis: {
                                //中间文字显示
                                show: true,
                            },
                        },
                        data: co.data || [
                            { value: 335, name: "直达" },
                            { value: 310, name: "邮件营销" },
                            { value: 234, name: "联盟广告" },
                            { value: 135, name: "视频广告" },
                            { value: 1048, name: "百度" },
                        ],
                    },
                ],
                color: [
                    "#FF9600",
                    "#909AF4",
                    "#5DD4CA",
                    "#81D3F8",
                    "#F49590",
                    "#8BCC63",
                    "#C79EDB",
                    "#47A8E8",
                    "#F6C41C",
                    "#BD8F59",
                ],
            };
        },
    },
    methods: {
        // 排序
        sortList(list, type) {
            if (type === "desc") {
                list.sort((a, b) => b.value - a.value);
            } else if (type === "asce") {
                list.sort((a, b) => a.value - b.value);
            }
        },
        // list裁剪（>>= n-1,归并到其他）
        sliceList(list, n) {
            const lessN = n - 1;
            let newList = [];
            if (list.length > 10) {
                list.forEach((v) => {
                    if (newList.length < lessN) {
                        newList.push(v);
                    } else if (newList.length === lessN) {
                        newList.push({
                            name: "其他",
                            value: v.value,
                        });
                    } else {
                        newList[lessN].value += v.value;
                    }
                });
            } else {
                newList = list;
            }
            return newList;
        },
    },
};
</script>
